import { IOptimizationType } from "../IOptimizationType";

export default class TitleValue implements IOptimizationType {
    readonly title: string;
    readonly value: string;
    constructor(title: string, value: string) {
        this.title = title;
        this.value = value;
    }
}
